import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Slices } from '../slices';

import { FEED_INITIAL_STATE } from './constants';
import { FeedSchema } from './types';

const feedSlice = createSlice({
    name: Slices.Feed,
    initialState: FEED_INITIAL_STATE,
    reducers: {
        setCategory: (state, action: PayloadAction<FeedSchema['category']>) => {
            state.category = action.payload;
        },
        setSort: (state, action: PayloadAction<FeedSchema['sort']>) => {
            state.sort = action.payload;
        },
        reset: () => FEED_INITIAL_STATE,
    },
});

export const { actions: feedActions, reducer: feedReducer } = feedSlice;
